import { SUBSCRIPTION_SERVICE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import {
  SubscriptionV3PaymentIntentData,
  SubscriptionV3PaymentIntentResponse
} from './types/subscriptionV3/SubscriptionV3PaymentIntentResponse'
import { flowFetch } from '@app/code/src/utils/flowFetch'
import { getRequestHeadersWithAuthHeader } from '../../components/org/utils'
import { migrateSubscriptionV3PaymentIntentResponseToSubscriptionV3PaymentIntentData } from './serialization/migrateSubscriptionV3'
import { subscriptionServiceV3ErrorHandler } from './subscriptionServiceV3ErrorHandler'

const CREATE_SUBSCRIPTION_URL = `${SUBSCRIPTION_SERVICE_ENDPOINT}/v3/subscriptions`

export interface CreateSubscriptionOptions {
  planId: string
  paymentMethodId?: string
  couponCode?: string
  orgName?: string
  planExtras?: Array<{ planExtraId: string; quantity: number }>
  token: string
}

export const createSubscriptionV3 = async (
  options: CreateSubscriptionOptions
): Promise<SubscriptionV3PaymentIntentData | undefined> => {
  const { token, ...body } = options
  if (body.paymentMethodId === undefined) body.paymentMethodId = ''
  const headers = getRequestHeadersWithAuthHeader(token)
  const res = await flowFetch<SubscriptionV3PaymentIntentResponse | undefined>(
    'POST',
    CREATE_SUBSCRIPTION_URL,
    { technicalArea: 'monetization' },
    {
      headers,
      body: JSON.stringify(body)
    },
    subscriptionServiceV3ErrorHandler
  )
  return res?.data
    ? migrateSubscriptionV3PaymentIntentResponseToSubscriptionV3PaymentIntentData(res.data)
    : undefined
}
